import React, { useState } from 'react';
import { AnimatedSection } from '../components/ui/AnimatedSection';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { CheckCircleIcon, ShieldCheckIcon, ClockIcon, StarIcon } from 'lucide-react';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <main className="w-full pt-24" data-id="element-178">
      <section className="py-20 md:py-32 bg-dark" data-id="element-179">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-180">
          <AnimatedSection data-id="element-181">
            <SectionHeading overline="APPLICATION" title="Apply for BioShift Coaching" description="This is not a sign-up form. It's an application. We work with a select number of committed individuals each quarter. Complete the application below and our team will review it within 48 hours." data-id="element-182" />
          </AnimatedSection>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 mt-20" data-id="element-183">
            {/* Form */}
            <AnimatedSection direction="right" className="lg:col-span-2" data-id="element-184">
              <div className="bg-surface border border-border p-8 md:p-12 shadow-2xl" data-id="element-185">
                {isSuccess ? <div className="text-center py-16" data-id="element-186">
                    <CheckCircleIcon className="w-16 h-16 text-gold mx-auto mb-6" data-id="element-187" />
                    <h3 className="text-3xl font-heading text-white mb-4" data-id="element-188">
                      Application Received
                    </h3>
                    <p className="text-muted text-lg mb-8 leading-relaxed" data-id="element-189">
                      Thank you for applying to BioShift. Our team will review
                      your application and reach out within 48 hours to schedule
                      your complimentary strategy call.
                    </p>
                    <div className="pt-8 border-t border-border" data-id="element-190">
                      <p className="text-white font-medium mb-6" data-id="element-191">
                        In the meantime, explore our methodology:
                      </p>
                      <Button to="/#methodology" variant="secondary" data-id="element-192">
                        Discover the BioShift Method
                      </Button>
                    </div>
                  </div> : <form onSubmit={handleSubmit} className="space-y-8" data-id="element-193">
                    <div className="border-b border-border pb-4 mb-8" data-id="element-194">
                      <h4 className="text-gold text-sm uppercase tracking-wider font-bold" data-id="element-195">
                        Step 1 of 2: Tell Us About You
                      </h4>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-196">
                      <div className="space-y-2" data-id="element-197">
                        <label htmlFor="name" className="text-sm font-medium text-white/80" data-id="element-198">
                          Full Name
                        </label>
                        <input type="text" id="name" required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors" data-id="element-199" />
                      </div>
                      <div className="space-y-2" data-id="element-200">
                        <label htmlFor="email" className="text-sm font-medium text-white/80" data-id="element-201">
                          Email Address
                        </label>
                        <input type="email" id="email" required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors" data-id="element-202" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-203">
                      <div className="space-y-2" data-id="element-204">
                        <label htmlFor="phone" className="text-sm font-medium text-white/80" data-id="element-205">
                          Phone Number
                        </label>
                        <input type="tel" id="phone" required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors" data-id="element-206" />
                      </div>
                      <div className="space-y-2" data-id="element-207">
                        <label htmlFor="income" className="text-sm font-medium text-white/80" data-id="element-208">
                          Annual Income Range
                        </label>
                        <select id="income" required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors appearance-none" data-id="element-209">
                          <option value="" disabled selected data-id="element-210">
                            Select an option
                          </option>
                          <option value="under-100k" data-id="element-211">Under $100K</option>
                          <option value="100k-200k" data-id="element-212">$100K – $200K</option>
                          <option value="200k-500k" data-id="element-213">$200K – $500K</option>
                          <option value="500k-plus" data-id="element-214">$500K+</option>
                          <option value="prefer-not-to-say" data-id="element-215">
                            Prefer not to say
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-216">
                      <label htmlFor="goals" className="text-sm font-medium text-white/80" data-id="element-217">
                        Current Health Goals
                      </label>
                      <textarea id="goals" rows={3} required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors resize-none" placeholder="What are you looking to achieve?" data-id="element-218"></textarea>
                    </div>

                    <div className="space-y-2" data-id="element-219">
                      <label htmlFor="tried" className="text-sm font-medium text-white/80" data-id="element-220">
                        What have you already tried that didn't work?
                      </label>
                      <textarea id="tried" rows={3} required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors resize-none" placeholder="Diets, trainers, programs, etc." data-id="element-221"></textarea>
                    </div>

                    <div className="space-y-2" data-id="element-222">
                      <label htmlFor="struggle" className="text-sm font-medium text-white/80" data-id="element-223">
                        Biggest Struggle
                      </label>
                      <textarea id="struggle" rows={3} required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors resize-none" placeholder="What has been holding you back?" data-id="element-224"></textarea>
                    </div>

                    <div className="space-y-2" data-id="element-225">
                      <label htmlFor="whyNow" className="text-sm font-medium text-white/80" data-id="element-226">
                        Why Now? What's changed that makes this the right time?
                      </label>
                      <textarea id="whyNow" rows={3} required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors resize-none" placeholder="Why are you ready to commit today?" data-id="element-227"></textarea>
                    </div>

                    <div className="space-y-2" data-id="element-228">
                      <label htmlFor="source" className="text-sm font-medium text-white/80" data-id="element-229">
                        How did you hear about BioShift?
                      </label>
                      <input type="text" id="source" required className="w-full bg-dark border border-border focus:border-gold focus:ring-1 focus:ring-gold outline-none text-white px-4 py-3 transition-colors" data-id="element-230" />
                    </div>

                    <div className="pt-4" data-id="element-231">
                      <Button type="submit" size="lg" className="w-full shadow-[0_0_20px_rgba(212,175,55,0.2)]" disabled={isSubmitting} data-id="element-232">
                        {isSubmitting ? 'Submitting Application...' : 'Submit Your Application'}
                      </Button>
                      <p className="text-muted text-xs text-center mt-4" data-id="element-233">
                        Your information is 100% confidential and will never be
                        shared.
                      </p>
                    </div>
                  </form>}
              </div>
            </AnimatedSection>

            {/* Sidebar */}
            <AnimatedSection direction="left" className="lg:col-span-1" data-id="element-234">
              <div className="sticky top-32 space-y-8" data-id="element-235">
                {/* What Happens Next */}
                <div className="bg-surface border border-border p-8" data-id="element-236">
                  <h3 className="text-xl font-heading text-white mb-8 border-b border-border pb-4" data-id="element-237">
                    What Happens After You Apply
                  </h3>

                  <div className="space-y-8" data-id="element-238">
                    <div className="flex items-start" data-id="element-239">
                      <div className="w-8 h-8 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center text-gold font-bold text-sm flex-shrink-0 mr-4" data-id="element-240">
                        1
                      </div>
                      <div data-id="element-241">
                        <p className="text-white font-bold mb-1" data-id="element-242">
                          Application Review
                        </p>
                        <p className="text-muted text-sm leading-relaxed" data-id="element-243">
                          Our team reviews your application within 48 hours.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start" data-id="element-244">
                      <div className="w-8 h-8 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center text-gold font-bold text-sm flex-shrink-0 mr-4" data-id="element-245">
                        2
                      </div>
                      <div data-id="element-246">
                        <p className="text-white font-bold mb-1" data-id="element-247">
                          Strategy Call
                        </p>
                        <p className="text-muted text-sm leading-relaxed" data-id="element-248">
                          If we're a good fit, we'll schedule a complimentary
                          strategy call.
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start" data-id="element-249">
                      <div className="w-8 h-8 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center text-gold font-bold text-sm flex-shrink-0 mr-4" data-id="element-250">
                        3
                      </div>
                      <div data-id="element-251">
                        <p className="text-white font-bold mb-1" data-id="element-252">
                          Custom Protocol
                        </p>
                        <p className="text-muted text-sm leading-relaxed" data-id="element-253">
                          We build your personalized transformation plan and
                          begin.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Trust Signals */}
                <div className="bg-surface border border-gold/20 p-8" data-id="element-254">
                  <h4 className="text-lg font-bold text-white mb-6" data-id="element-255">
                    Why Clients Trust BioShift
                  </h4>
                  <div className="space-y-4" data-id="element-256">
                    <div className="flex items-center" data-id="element-257">
                      <ShieldCheckIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-258" />
                      <span className="text-muted text-sm" data-id="element-259">
                        100% Confidential Application
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-260">
                      <ClockIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-261" />
                      <span className="text-muted text-sm" data-id="element-262">
                        Response Within 48 Hours
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-263">
                      <StarIcon className="w-5 h-5 text-gold mr-3 flex-shrink-0" data-id="element-264" />
                      <span className="text-muted text-sm" data-id="element-265">
                        4.9/5 Average Client Rating
                      </span>
                    </div>
                  </div>
                </div>

                {/* Scarcity Note */}
                <div className="bg-dark border border-gold/30 p-6" data-id="element-266">
                  <p className="text-gold font-bold mb-2 uppercase tracking-wider text-sm" data-id="element-267">
                    Limited Availability
                  </p>
                  <p className="text-muted text-sm leading-relaxed" data-id="element-268">
                    We accept a maximum of 15 new clients per quarter to
                    maintain the highest level of coaching quality.
                  </p>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>
    </main>;
}